module.exports = __webpack_public_path__ + "static/media/design-leggings.810b67e2.svg";